import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-authorized',
    templateUrl: './not-authorized.component.html',
    styleUrls: ['./not-authorized.component.scss'],
    standalone: false
})
export class NotAuthorizedComponent implements OnInit {
  ngOnInit(): void {
    // intentionally empty.
  }
}
